import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import CommentDetailsService from "../../../../services/screens/admin/homework/CommentDetailsService";
import { ActionTypes } from "../../../actionTypes/screens/admin/homework/CommentDetailsActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.homework.commentdetails;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            CommentDetailsService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),
    
    cacheComments: (commentsResult) => ({
        type: ActionTypes.CACHE_COMMENTS,
        commentsResult
    }),

    changeUnit: (direction) => ({
        type: ActionTypes.CHANGE_UNIT,
        direction
    }),

    saveComments: (userHomeworkId, commentsResult) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_COMMENTS_ASYNC, userHomeworkId, commentsResult });

            CommentDetailsService.saveComments(
                { userHomeworkId, commentsResult },
                response => {
                    dispatch(Actions.saveCommentsSuccess(response, commentsResult));
                },
                error => {
                    dispatch(Actions.saveCommentsFailure(error));
                }
            );
        };
    },

    saveCommentsSuccess: (data, commentsResult) => ({
        type: ActionTypes.SAVE_COMMENTS_SUCCESS,
        parentType: ActionTypes.SAVE_COMMENTS_ASYNC,
        postReducer: saveCommentsSuccessReducer,
        data,
        commentsResult
    }),

    saveCommentsFailure: error => ({
        type: ActionTypes.SAVE_COMMENTS_FAILURE,
        parentType: ActionTypes.SAVE_COMMENTS_ASYNC,
        error
    }),

    loadNext: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            CommentDetailsService.loadNext(
                { ...vo, searchType: 0, pageIndex: 1, pageSize: 1 },
                response => {
                    dispatch(Actions.loadNextSuccess(response));
                },
                error => {
                    dispatch(Actions.loadNextFailure(error));
                }
            );
        };
    },

    loadNextSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadNextSuccessPostReducer,
        data
    }),

    loadNextFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    units: null,
    unitIndex: 0,
    completed: false,
    nextUserHomework: null,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    let unitIndex = 0;
    for (let unit of data.units) {
        unit.data = JSON.parse(unit.data) || {};
        if (unit.revisedOn) {
            unitIndex += 1;
        }

    }
    if (unitIndex === data.units.length) {
        unitIndex = 0;
    }
    return { ...state, units: data.units, unitIndex, completed: false, nextUserHomework: null };
};

const changeUnitReducer = (state, { direction }) => {
    let unitIndex = state.unitIndex + direction;
    return { ...state, unitIndex };
}

const cacheCommentsReducer = (state, { commentsResult }) => {
    const units = Array.from(state.units);
    let idx = units.findIndex(u => u.userHomeworkUnitId === commentsResult.userHomeworkUnitId);
    let { unitIndex } = state;
    if (idx > -1) {
        let unit = units[idx];
        unit.comments = commentsResult.comments;
        unit.score = commentsResult.score;
        unit.revisedOn = new Date().toLocaleString();
        units.splice(idx, 1, unit);
        unitIndex -= 1;
    }
    return { ...state, units, unitIndex };
}

const saveCommentsSuccessReducer = (state, { commentsResult }) => {
    const units = Array.from(state.units);
    let idx = units.findIndex(u => u.userHomeworkUnitId === commentsResult.userHomeworkUnitId);
    let { completed, unitIndex } = state;
    if (idx > -1) {
        let unit = units[idx];
        unit.comments = commentsResult.comments;
        unit.score = commentsResult.score;
        unit.revisedOn = new Date().toLocaleString();
        units.splice(idx, 1, unit);
        completed = idx === units.length - 1;
        if (!completed) {
            unitIndex += 1;
        }
    }
    return { ...state, units, completed, unitIndex };
}


const loadNextSuccessPostReducer = (state, { data }) => {
    return { ...state, nextUserHomework: data }
}

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CHANGE_UNIT]: changeUnitReducer,
    [ActionTypes.CACHE_COMMENTS]: cacheCommentsReducer,
    [ActionTypes.SAVE_COMMENTS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_COMMENTS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_COMMENTS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_NEXT]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_NEXT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_NEXT_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
